import React, { useState, useEffect } from "react";
import { formatTime } from "../../lib/utils";

interface ExpirationTimerProps {
  expiryTime: number; // Time in seconds
  timeLeft: any;
  setTimeLeft: any;
}

const ExpirationTimer: React.FC<ExpirationTimerProps> = ({
  expiryTime,
  timeLeft,
  setTimeLeft,
}) => {
  useEffect(() => {
    if (timeLeft === -1) {
      return;
    }
    const storedTime = localStorage.getItem("startTime");
    let startTime: number;

    if (storedTime) {
      startTime = parseInt(storedTime, 10);
    } else {
      startTime = Date.now();
      localStorage.setItem("startTime", startTime.toString());
    }

    const interval = setInterval(() => {
      const currentTime = Date.now();
      const timeElapsed = Math.floor((currentTime - startTime) / 1000);
      const newTimeLeft = expiryTime - timeElapsed;

      if (newTimeLeft <= 0) {
        clearInterval(interval);
        localStorage.removeItem("startTime");
        setTimeLeft(-1);
      } else {
        setTimeLeft(newTimeLeft);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expiryTime, timeLeft]);

  const displayTime = timeLeft === -1 ? "0:00" : formatTime(timeLeft);

  return (
    <div className="text-center mb-2 font-medium">
      <h1>{displayTime}</h1>
    </div>
  );
};

export default ExpirationTimer;
